import * as React from "react";
const SvgFiRrCircleExclamationCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-exclamation-check_svg__a)">
      <path
        fill="#062147"
        d="M10 13a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1m-1.5 2.5a1.5 1.5 0 1 0 3.002-.001A1.5 1.5 0 0 0 8.5 15.5m8.875 1.755a1 1 0 0 0-1.412.078A8.02 8.02 0 0 1 10.013 20c-4.406-.006-7.989-3.593-7.989-8s3.583-7.994 7.99-8a8.015 8.015 0 0 1 7.534 5.333.997.997 0 0 0 1.274.609 1 1 0 0 0 .61-1.275A10.02 10.02 0 0 0 10.033 2h-.045C4.491 2.019.022 6.497.022 12s4.47 9.981 9.967 10h.044a10.02 10.02 0 0 0 7.42-3.333 1 1 0 0 0-.078-1.412m6.345-7.95a1 1 0 0 0-1.415-.023l-3.503 3.387c-.442.44-1.16.441-1.631-.028l-1.492-1.375a1 1 0 1 0-1.355 1.471l1.463 1.347a3.13 3.13 0 0 0 2.219.918c.802 0 1.596-.303 2.198-.906l3.492-3.375a1 1 0 0 0 .023-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-exclamation-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleExclamationCheck;
